import {
    type BreakPeriod,
    type Period,
    type PeriodWithSpecializationStyle,
    type PeriodWithExamStyle,
    type PeriodWithStandardStyle,
} from './Period.types';

export function isPeriodWithSpecializationStyle(period: Period): period is PeriodWithSpecializationStyle {
    // NOTE: there's also a projectStyle property, but I'm not sure we're using it for anything important.
    // It seems wrong for this to look for a specializationStyle if the period's style is project, but this is mimicking
    // the V1 logic scheduleHelpers.ts.  Sometimes the final period is a (capstone) project period, but has a
    // specializationStyle so that it gets lumped with the preceding specialization periods in the schedule box.
    return (period.style === 'specialization' || period.style === 'project') && !!period.specializationStyle;
}

export function isPeriodWithExamStyle(period: Period): period is PeriodWithExamStyle {
    return period.style === 'exam' || period.style === 'review';
}

export function isPeriodWithStandardStyle(period: Period): period is PeriodWithStandardStyle {
    return period.style === 'standard';
}

export function isBreakPeriod(period: Period): period is BreakPeriod {
    return period.style === 'break';
}
